module.exports = __webpack_public_path__ + "static/media/racket.926c4f80.svg";